export const TOAST_ID = {
  ACCEPT_INVITATION_FAILED: 'ACCEPT_INVITATION_FAILED',
  ACCEPT_INVITATION_SUCCESS: 'ACCEPT_INVITATION_SUCCESS',
  UNACHIEVABLE_RESULTS: 'UNACHIEVABLE_RESULTS',
  ADD_BUNDLE_SUCCESS_NOT_VISIBLE: 'ADD_BUNDLE_SUCCESS_NOT_VISIBLE',
  ADD_LICENSE_SUCCESS: 'ADD_LICENSE_SUCCESS',
  ADD_MATERIAL_SUCCESS: 'ADD_MATERIAL_SUCCESS',
  ADD_MEMBER_SUCCESS: 'ADD_MEMBER_SUCCESS',
  ADD_SMARTSCHOOL_ACCOUNT_ERROR: 'ADD_SMARTSCHOOL_ACCOUNT_ERROR',
  CONNECT_CALLBACK_ERROR: 'CONNECT_CALLBACK_ERROR',
  CONNECT_CALLBACK_SUCCESS: 'CONNECT_CALLBACK_SUCCESS',
  COPIED_COURSE_CODE: 'COPIED_COURSE_CODE',
  COPIED_INVITE_LINK: 'COPIED_INVITE_LINK',
  COPIED_LOGIN_DETAILS: 'COPIED_LOGIN_DETAILS',
  DEFAULT_ERROR: 'DEFAULT_ERROR',
  DEFAULT_SUCCESS: 'DEFAULT_SUCCESS',
  DELETE_SUBJECT_YEAR_SUCCESS: 'DELETE_SUBJECT_YEAR_SUCCESS',
  DELETE_USER_SCHOOL_SUCCESS: 'DELETE_USER_SCHOOL_SUCCESS',
  DISCONNECT_CALLBACK_ERROR: 'DISCONNECT_CALLBACK_ERROR',
  DISCONNECT_CALLBACK_SUCCESS: 'DISCONNECT_CALLBACK_SUCCESS',
  EDIT_MATERIAL_SUCCESS: 'EDIT_MATERIAL_SUCCESS',
  IMPORTED_SMARTSCHOOL_GROUPS_SUCCESS: 'IMPORTED_SMARTSCHOOL_GROUPS_SUCCESS',
  LICENSE_TRANSFER_CANCEL_FAILED: 'LICENSE_TRANSFER_CANCEL_FAILED',
  LICENSE_TRANSFER_CANCELLED: 'LICENSE_TRANSFER_CANCELLED',
  LICENSE_TRANSFER_SUCCESS: 'LICENSE_TRANSFER_SUCCESS',
  LINK_STUDENT_SUCCESS: 'LINK_STUDENT_SUCCESS',
  MATERIAL_SHARE_SUCCESS: 'MATERIAL_SHARE_SUCCESS',
  MULTIPLE_SCORABLE_ITEMS: 'MULTIPLE_SCORABLE_ITEMS',
  NO_LICENSE: 'NO_LICENSE',
  PERSONAL_GROUP_SUCCESS: 'PERSONAL_GROUP_SUCCESS',
  PERSONAL_GROUP: 'PERSONAL_GROUP',
  REMOVE_GROUP_SUCCESS: 'REMOVE_GROUP_SUCCESS',
  SKORE_EXPORT_SUCCESS: 'SKORE_EXPORT_SUCCESS',
  SMARTSCHOOL_DECOUPLING_ERROR: 'SMARTSCHOOL_DECOUPLING_ERROR',
  SMARTSCHOOL_VERIFICATION_ERROR: 'SMARTSCHOOL_VERIFICATION_ERROR',
  STUDENT_INVITE_ALREADY_ACCEPTED: 'STUDENT_INVITE_ALREADY_ACCEPTED',
  STUDENT_INVITE_ALREADY_INVITED: 'STUDENT_INVITE_ALREADY_INVITED',
  STUDENT_INVITE_EMAIL_NOT_FOUND: 'STUDENT_INVITE_EMAIL_NOT_FOUND',
  STUDENT_INVITE_ERROR: 'STUDENT_INVITE_ERROR',
  STUDENT_REMOVE_ERROR: 'STUDENT_REMOVE_ERROR',
  STUDENT_REMOVE_SUCCESS: 'STUDENT_REMOVE_SUCCESS',
  LICENSE_TRANSFER_ACCEPTED: 'LICENSE_TRANSFER_ACCEPTED',
  LICENSE_TRANSFER_DECLINED: 'LICENSE_TRANSFER_DECLINED',
} as const;

export type ToastId = typeof TOAST_ID[keyof typeof TOAST_ID];
